import { XCircle } from "lucide-react";

type Tr = (es: string, en: string) => string;

export function WhatsAppDisconnectedNotice({ tr }: { tr: Tr }) {
  return (
    <div
      className="mt-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2.5 text-red-950"
      role="alert"
      data-wapp-disconnected
    >
      <div className="flex items-start gap-2">
        <XCircle
          className="mt-0.5 h-4 w-4 shrink-0 text-red-600"
          strokeWidth={2}
          aria-hidden
        />
        <div className="min-w-0 space-y-1">
          <p className="text-sm font-medium leading-snug">
            {tr("Número desconectado", "Number disconnected")}
          </p>
          <p className="text-xs leading-snug opacity-90">
            {tr(
              "Meta quitó el acceso de Eloria a este número, así que Eloria no puede enviar ni recibir mensajes por él. Vuelve a conectarlo para restablecerlo.",
              "Meta removed Eloria's access to this number, so Eloria cannot send or receive messages on it. Reconnect it to restore it.",
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
